import React from "react";
import { cn } from "../../lib/utils";

const TopicBadge = ({ children, className, ...props }) => {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium",
        "bg-purple-50 text-purple-700 border border-purple-200",
        "dark:bg-purple-900/20 dark:text-white dark:border-purple-800",
        "hover:bg-purple-100 dark:hover:bg-purple-900/30 transition-colors",
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};

export { TopicBadge }; 